// extracted by mini-css-extract-plugin
export default {"inputContainer":"SearchInput_inputContainer__PJCP6","fieldLabel":"SearchInput_fieldLabel__AoRKl","field":"SearchInput_field__8fuAE","crossIcon":"SearchInput_crossIcon__F9d6E"};